import { render, staticRenderFns } from "./ResultsTrouble.vue?vue&type=template&id=29f0d1c2"
import script from "./ResultsTrouble.vue?vue&type=script&lang=js"
export * from "./ResultsTrouble.vue?vue&type=script&lang=js"
import style0 from "./ResultsTrouble.vue?vue&type=style&index=0&id=29f0d1c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports